// definitions for estimate item actions
export const NEEDS_ACTION = 'Requires Action';
export const APPROVED = 'Estimate Approved';
export const ITEM_SKIPPED = 'Skipped';
export const PARTIAL_APPROVAL = 'Partially Approved';
export const DECLINED = 'Estimate Declined';

// estimate status definitions
export const WORK_IN_PROGRESS = 'Work In Progress';
export const ESTIMATE_PENDING = 'Estimate Pending';
export const ESTIMATE_PROVIDED = 'Estimate Provided';
export const ESTIMATE_APPROVED = 'Estimate Approved';
export const ESTIMATE_DECLINED = 'Estimate Declined';
export const CLARIFICATION_NEEDED = 'Clarification Needed';
export const PARTS_ORDERED = 'Parts Ordered';
export const IN_TRANSIT = 'Package In Transit';
export const DELIVERED = 'Delivered';
export const RECEIVED = 'Received';
export const SHIPPED = 'Shipped';

// item statuses that should be able be able to be paid for
export const VALID_CHECKOUT_VALUES = [
  APPROVED,
  PARTIAL_APPROVAL,
  DECLINED,
];
